// @flow

import { get } from 'lodash';

import createReducer from 'Store/utils/createReducer';

import {
  FETCH_CUSTOMER,
  FETCH_CUSTOMER_RESOLVED,
  FETCH_CUSTOMER_REJECTED,
} from './customer.constants';

const initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_CUSTOMER](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_CUSTOMER_RESOLVED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      data: get(action, 'payload'),
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_CUSTOMER_REJECTED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
});
